import { render } from "./PantryIngredientEmptyView.vue?vue&type=template&id=2c25ec26&ts=true"
import script from "./PantryIngredientEmptyView.vue?vue&type=script&lang=ts"
export * from "./PantryIngredientEmptyView.vue?vue&type=script&lang=ts"

import "./PantryIngredientEmptyView.vue?vue&type=style&index=0&id=2c25ec26&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__